import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../context/LanguageContext.js';

function NotFound() {
  const { language, translations } = useContext(LanguageContext);

  return (
    <div className="page not-found">
      <h1>{translations[language].pages.not_found.h1}</h1>
      <p>{translations[language].pages.not_found.p1}</p>
      <Link to="/">{translations[language].pages.not_found.p2}</Link>
    </div>
  );
}

export default NotFound;